import React, { ChangeEvent, cloneElement, FC } from 'react';
import { Box } from '../../../Box';
import { getTrigger } from '../../triggers';
import { MultiSelectMobileProps, OnChange } from '../../types';

import styles from './index.module.css';

const wrapEventHandler = (onChange?: OnChange) => {
  if (!onChange) {
    return undefined;
  }

  return (e: ChangeEvent<HTMLSelectElement>) =>
    onChange({ value: [...e.target.selectedOptions].map((x) => x.value) });
};

export const MultiSelectMobile: FC<MultiSelectMobileProps> = ({
  options,
  onChange,
  value,
  title,
  style,
  disabled,
  placeholder,
  kind,
  size,
  intent,
  className,
  classNames,
  customTrigger,
  dataRole,
  intentType
}) => {
  const Trigger = getTrigger(kind);

  const triggerProps = {
    value,
    title,
    disabled,
    intent,
    placeholder,
    className: classNames?.trigger,
    size,
    intentType
  };

  return (
    <Box
      style={style}
      data-role={dataRole}
      className={`${styles.root} ${className}`}
    >
      {customTrigger ? (
        cloneElement(customTrigger, triggerProps)
      ) : (
        <Trigger {...triggerProps} />
      )}
      <select
        value={value}
        multiple={true}
        disabled={disabled}
        className={styles.select}
        onChange={wrapEventHandler(onChange)}
      >
        {options.map((option) => (
          <option value={option.value} key={`${option.value}-${option.title}`}>
            {option.title}
          </option>
        ))}
      </select>
    </Box>
  );
};
